/*
 * @CopyRight    : 广州仰望星空云科技有限公司
 * @Author       : Kyle
 * @Email        : linyukai@xinyu668.com
 * @CreateTime   : 2023-08-15 14:49:03
 * @Description  : api初始化
 */
// =================================================================

import { constConf } from '@GLOBAL/constConf';
import { key, appData } from '@GLOBAL/bridge';
import { request } from '@ywxk/request';
import { createApi } from '@ywxk/api/createApi';
import { getQueryString } from '@ywxk/util/url';

const { SERVER_HEAD, IS_PROD } = constConf

const firstWordUpperCase = string => string[0].toUpperCase() + string.substring(1);

// <===================================== 服务端本地调试 ======================================
const ip = getQueryString('ip') || ''
const server = getQueryString('server') || ''

// 一般 obj，是三段式， 例如： mizhua.actgame.ActgameExtObj
// 如果中间段等于 server就可以转发,
const prot = [
  { "server": "actgame", "port": "19986" },
  { "server": "activity", "port": "20142" },
  { "server": "admin", "port": "19049" },
  { "server": "assets", "port": "19077" },
  { "server": "chat", "port": "20233" },
  { "server": "coupon", "port": "20011" },
  { "server": "crackegg", "port": "19099" },
  { "server": "effect", "port": "20239" },
  { "server": "friend", "port": "19009" },
  { "server": "gift", "port": "19087" },
  { "server": "index", "port": "20154" },
  { "server": "ktv", "port": "20027" },
  { "server": "live", "port": "40040" },
  { "server": "mission", "port": "20020" },
  { "server": "neonactivity", "port": "19910" },
  { "server": "nobility", "port": "19170" },
  { "server": "pcindex", "port": "20154" },
  { "server": "robot", "port": "20001" },
  { "server": "room", "port": "19048" },
  { "server": "store", "port": "19042" },
  { "server": "timer", "port": "20162" },
  { "server": "user", "port": "19047" },
  { "server": "userstatus", "port": "19055" },
  { "server": "virtualroom", "port": "19991" }
].reduce((obj, item) => {
  obj[item.server] = item.port
  return obj
}, {})

function getURL(fileName) {
  // 非正式并且存在配置
  if (!IS_PROD && server.indexOf(fileName) !== -1 && ip) {
    return `http://${ip}:${prot[fileName]}`
  } else {
    return null
  }
}
// ====================================== 服务端本地调试 =====================================>

createApi((fileName, apiName, data = {}, opt = {}) => {
  // 由于pc端有分身功能，所以需要在上下文中默认带上roomid
  const roomid = `${appData?.profile?.roomId || appData?.roomId || ''}`

  let serverName = `${SERVER_HEAD}.` + (opt.SERVER_TAIL ? opt.SERVER_TAIL : `${fileName}.${firstWordUpperCase(fileName)}ExtObj`);

  if (opt?.serverName) {
    serverName = opt?.serverName;
  }


  const params = {
    url: opt.url || getURL(fileName),
    // 部分不规则命名优先传参
    reqDesction: opt.reqDesction || `${apiName}Req`, // 入参解析字段
    resDesction: opt.resDesction || `${apiName}Res`, // 出参解析字段
    serverName, // 请求服务
    funcName: apiName, // 请求方法
    data, // 请求原数据
    rpcOpts: {
      'X-Token': key || '',
      roomid,
      ...(opt.rpcOpts || {})
    } // rpc传输上下文
  };
  return request(params);
})
